import {v4 as uuid} from '../utils/uuid.js'
import { toKebab } from '../utils/convertCase.js';

export class ClassBase {
	constructor(el) {
		this.$el = $(el).eq(0);
		this.$el.data(`${toKebab(this.constructor.name)}-instance`, this);
		this.id = uuid()

		this.op = {
			addEvent: true,
		}
	}
}